import { render, staticRenderFns } from "./UserPermissionsInput.vue?vue&type=template&id=17683cfe&scoped=true"
import script from "./UserPermissionsInput.vue?vue&type=script&lang=js"
export * from "./UserPermissionsInput.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionsInput.vue?vue&type=style&index=0&id=17683cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17683cfe",
  null
  
)

export default component.exports